import React from 'react'
/**
 * 주어진 값이 없으면, 랜덤하게 값을 생성하여 반환한다. 컴포넌트의 unique id 를 생성하기 위해 활용하면 좋다.
 */
export function useRandomDefaultValue(givenValue) {
  var v = React.useState(function () {
    if (givenValue) {
      return givenValue
    }
    return Array.from({ length: 36 }, function () {
      return Math.random().toString(36)[2]
    }).join('')
  })[0]
  return v
}
//# sourceMappingURL=useRandomDefaultValue.js.map
